import { createSlice } from '@reduxjs/toolkit'
import { getRequest } from 'services/axiosBaseClient';

const axios = require("axios");
const API_URL = "https://jsonplaceholder.typicode.com/todos";

export const chargerSlice = createSlice({
  name: "chargerList",
  initialState: {
    data: []
  },
  reducers: {
    fetchChargerList: (state, action) => {
      state.data = action.payload;
    }
    // ,
    // getTodo: (state, action) => {
    //   state.data = [action.payload];
    // }
  }
});

export const chargerdropdownTodoAsync = (data) => async (dispatch) => {
  try {
  getRequest('sites/evses').then((response) => {
  if (response.status === 200) {
      // debugger
    let dataArray=response?.data?.siteEvse
    let timeZone=[];
    let chargerArray = [{ label: "Select All", value: '0' }];
     dataArray.map((item) => {
      if(item.name!==undefined){
      chargerArray.push({ label: item.name, value: item.evseId,name:'charger', siteId: item?.site?.siteId,timeZone:item?.site?.timezone  });
      timeZone.push({value: item.evseId,timeZone:item?.site?.timezone  }) 
    }
    })
    dispatch(fetchChargerList(chargerArray));
    localStorage.setItem('timezone',JSON.stringify(timeZone))
    
  } else {
    return ["vaibhav"]
  }
}).catch((err) => {
  console.error("Error Redux", err)
})
}
 catch (err) {
  throw new Error(err);
}
}




export const { fetchChargerList } = chargerSlice.actions
// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const getChargerList = (state) => state?.chargerList?.data

export default chargerSlice.reducer
